<template>
  <base-card class="mb-4" >
    <v-layout row pa-3>
      <v-flex xs5 sm4 pa-0>
        <div class="text-xs-left">
          <v-img
            height="160px"
            sizes="160px"
            :src="artwork.media.url"
            :srcset="artwork.media.srcset"
            :style="{'background-color': artwork.media.color }"
          />
        </div>
      </v-flex>

      <v-flex xs7 sm8 pa-0>
        <tk-btn icon small class="close-btn" @click="$cart.removeItem(artwork.id)">
          <v-icon size="20">far fa-trash-alt</v-icon>
        </tk-btn>

        <v-layout fill-height row wrap>
          <v-flex xs12 pl-4 pt-0 mr-0 pr-5>
            <router-link
              :to="{ name: 'artist.artwork', params: { artistSlug: artwork.artist.slug, artworkId: artwork.id }}"
              class="title"
            >{{ artwork.title }}</router-link>

            <div class="mt-2">
              <router-link
                v-if="artwork.artist.isVisible"
                class="subheading"
                :to="{ name: 'artist.single', params: { artistSlug: artwork.artist.slug} }"
              >{{ artwork.artist.name }}</router-link>
              <h2 v-else class="subheading">{{ artwork.artist.name }}</h2>
            </div>
          </v-flex>

          <v-flex xs12 pr-4 pb-2 offset-xs3 offset-sm6 align-self-end>
            <v-layout row>
              <v-flex shrink pa-0 class="subheading font-weight-medium">{{ $t('ARTWORK.PRICE') }}</v-flex>
              <v-flex
                grow
                pa-0
                text-xs-right
                class="subheading font-weight-bold"
              >{{ artwork.price }} €</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex shrink pa-0>{{ $t('CART.INCLUDE') }} {{ $t('CART.VAT')}}</v-flex>
              <v-flex grow pa-0 text-xs-right>{{ artwork.vatAmount }} € ({{ artwork.vatRate }} %)</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-divider class="mt-2" color="black"/>
  </base-card>
</template>

<script>
export default {
  props: {
    artwork: { required: true }
  },
  created() {
    console.log(this.artwork);
  }
};
</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0.7;
}
a.title,
a.subheading {
  color: #000;
  text-decoration: none;

  &:hover {
    color: #414141;
  }
}
</style>
